import { LOCALE_ID } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { resolveBrowserLocaleId } from './app/_helpers/browser-locale';

resolveBrowserLocaleId()
  .then(localeId =>
    bootstrapApplication(AppComponent, {
      ...appConfig,
      providers: [...appConfig.providers, { provide: LOCALE_ID, useValue: localeId }],
    }),
  )
  .catch(err => console.error(err));
